import { render, staticRenderFns } from "./CreateItineraryItem.vue?vue&type=template&id=b61b5f8e&scoped=true&"
import script from "./CreateItineraryItem.vue?vue&type=script&lang=js&"
export * from "./CreateItineraryItem.vue?vue&type=script&lang=js&"
import style0 from "./CreateItineraryItem.vue?vue&type=style&index=0&id=b61b5f8e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b61b5f8e",
  null
  
)

export default component.exports